<template>
    <svg :width="width" :height="height" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.8066 7.49128C11.5228 4.88498 13.5316 1.20638 13.6179 1.05347C13.7429 0.835875 13.7425 0.568172 13.6168 0.350953C13.4911 0.133734 13.2592 0 13.0082 0C10.8031 0 9.07632 0.626531 7.8759 1.86225C5.8247 3.97373 5.91985 7.26 5.96044 8.66334C5.96494 8.81878 5.96884 8.95312 5.96884 9.05288C5.96884 10.0948 6.13599 11.0567 6.28351 11.9054C6.37857 12.4523 6.46065 12.9246 6.47523 13.296C6.49084 13.6935 6.41827 13.7846 6.41518 13.7882C6.40482 13.8005 6.31857 13.8464 6.08537 13.8464C5.8194 13.8464 5.62332 13.7595 5.4496 13.5647C4.77104 12.8039 4.72412 10.7263 4.85387 9.59597C4.87707 9.39666 4.81402 9.19697 4.68057 9.04716C4.54716 8.89734 4.3561 8.81166 4.15548 8.81166C2.32993 8.81166 0.96582 11.797 0.96582 14.4663C0.96582 15.7211 1.2182 16.9503 1.71596 18.1197C2.19718 19.2502 2.88338 20.2706 3.75559 21.1523C5.57209 22.9887 7.96707 24 10.4994 24C13.042 24 15.4364 23.003 17.2415 21.1927C19.042 19.387 20.0335 16.9981 20.0335 14.4662C20.0335 11.2355 17.5057 8.52492 15.8066 7.49128ZM10.4994 22.5938C6.09399 22.5938 2.37212 18.8718 2.37212 14.4662C2.37212 13.3948 2.62777 12.2701 3.07351 11.3806C3.17762 11.1728 3.28445 10.9946 3.38987 10.8444C3.40163 12.0044 3.58538 13.5857 4.3989 14.4993C4.83774 14.9921 5.42091 15.2526 6.08541 15.2526C6.70618 15.2526 7.17924 15.0645 7.49134 14.6934C8.07484 13.9997 7.89573 12.9692 7.66904 11.6646C7.53127 10.8719 7.37513 9.97345 7.37513 9.05283C7.37513 8.93269 7.37096 8.78902 7.36618 8.62256C7.32769 7.29328 7.24758 4.52723 8.8846 2.84212C9.61946 2.08561 10.6455 1.6252 11.9434 1.46766C11.7969 1.95422 11.6706 2.57189 11.6657 3.26348C11.6549 4.7873 12.2378 6.96609 15.0758 8.69269C16.4489 9.52805 18.6273 11.8342 18.6273 14.4662C18.6272 18.9478 14.9811 22.5938 10.4994 22.5938Z" :fill="color" :fill-opacity="opacity"/>
    </svg>
</template>

<script>
export default {
	name: "StreamerIcon",
	props: {
		height: {
			type: Number,
			default: 24
		},
		width: {
			type: Number,
			default: 24
		},
        color: {
            type: String,
            default: '#ffffff'
        },
        opacity: {
            type: String,
            default: ''
        }
  	}
}
</script>
